import * as Yup from "yup";
import i18n from "../../i18n";

export const validationSchema = Yup.object({
  name: Yup.string().nullable().required(i18n.t("Please enter a group name")),
});
